module.exports = {"450804100":"覃塘镇","450804101":"东龙镇","450804102":"三里镇","450804103":"黄练镇","450804104":"石卡镇","450804105":"五里镇","450804106":"樟木镇","450804200":"山北乡","450804203":"蒙公乡","450804204":"大岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450804.json
// module id = 1956
// module chunks = 0